import React, { Component } from 'react';
import PropTypes from 'prop-types';

const newlineToBr = (text) => (
  text.split('\n').map((item, index) => (
    <span key={`${index.toString()}br`}>
      {item}
      <br />
    </span>
  ))
);

const truncate = (text, end) => `${text.substring(0, end)}...`;

/**
 * A block of text that collapses or expands based on the number of characters.
 */
export class ExpandableText extends Component {
  static propTypes = {
    /** Additional CSS classes of the component. */
    className: PropTypes.string,
    /** Toggle whether to render all newlines accurately by using <br /> */
    // TODO move this functionality outside of this component
    convertNewLinesToBr: PropTypes.bool,
    /** Number of characters at which the text will be truncated when collapsed. */
    cutoff: PropTypes.number,
    /** Text that is expanded or collapsed. */
    text: PropTypes.string,
  }

  static defaultProps = {
    className: '',
    convertNewLinesToBr: true,
    cutoff: 280,
    text: '',
  }

  state = {
    expanded: false,
  }

  handleToggle = () => {
    this.setState((prevState) => ({ expanded: !prevState.expanded }));
  }

  render() {
    const { className, convertNewLinesToBr, cutoff, text } = this.props;
    const { expanded } = this.state;
    const long = text.length > cutoff;
    let renderedText = (expanded || !long) ? text : truncate(text, cutoff);
    if (convertNewLinesToBr) {
      renderedText = newlineToBr(renderedText);
    }
    return (
      <p className={`ExpandableText text ${className}`}>
        {renderedText}
        {long && (
          <button type="button" onClick={this.handleToggle} className={`ViewMore${expanded ? ' expanded' : ''}`}>
            {`show ${expanded ? 'less' : 'more'}`}
          </button>
        )}
      </p>
    );
  }
}

export default ExpandableText;
